import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/metalogic.kz/httpdocs/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/metalogic.kz/httpdocs/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/metalogic.kz/httpdocs/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/var/www/vhosts/metalogic.kz/httpdocs/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/vhosts/metalogic.kz/httpdocs/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/var/www/vhosts/metalogic.kz/httpdocs/src/components/modules/preloader/preloader.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/vhosts/metalogic.kz/httpdocs/src/components/providers/locomotive-scroll.tsx");
